<template>
  <div class="d-flex flex-wrap mr-2 pl-2">
    <v-tooltip v-for="(item, index) in accounts" :key="item.id" bottom>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <AccountAvatar
            v-if="item && index < maxItemsToShow"
            class="chip-over-chip"
            :size="avatarSize"
            :fontSize="fontSize"
            :account="item"
            :disabled="disabled"
            @remove="$emit('remove', item)"
          />
        </span>
      </template>
      <span v-if="item">{{ getItemTitle(item) }}</span>
    </v-tooltip>
    <v-menu
      v-if="moreItemsSelected"
      open-on-hover
      nudge-bottom="32"
      max-height="270"
    >
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          class="more-items-selected blue white--text d-flex justify-center align-center chip-over-chip font-weight-600"
          :style="{ fontSize, width: avatarSize, height: avatarSize }"
          @click.stop="$emit('click')"
        >
          +{{ moreItemsSelected }}
        </div>
      </template>
      <v-card
        class="ma-0 pa-0 blue-grey lighten-3 px-4 pt-4 pb-1"
        dense
        elevation="2"
      >
        <p
          v-for="(item, index) in accounts.slice(
            maxItemsToShow,
            accounts.length
          )"
          class="ma-0 pa-0 label mb-3 blue-grey--text text--darken-2 font-weight-400"
          :key="`${item}${index}`"
        >
          {{ getItemTitle(item) }}
        </p>
      </v-card>
    </v-menu>
    <div
      v-if="loading && !accounts.length"
      class="d-flex align-center flex-grow-1 selection-skeletons"
    >
      <v-skeleton-loader
        class="selection-avatar chip-over-chip"
        type="avatar"
      />
      <v-skeleton-loader
        class="selection-avatar chip-over-chip"
        type="avatar"
      />
      <v-skeleton-loader
        class="selection-avatar chip-over-chip"
        type="avatar"
      />
      <v-skeleton-loader
        class="selection-avatar chip-over-chip"
        type="avatar"
      />
      <v-skeleton-loader
        class="selection-avatar chip-over-chip"
        type="avatar"
      />
      <v-skeleton-loader
        class="selection-avatar chip-over-chip"
        type="avatar"
      />
    </div>
  </div>
</template>

<script>
import AccountAvatar from './AccountAvatar.vue'
import userMixin from '@/mixins/userMixin.vue'

export default {
  name: 'AssigneesSelection',

  mixins: [userMixin],

  components: {
    AccountAvatar,
  },

  props: {
    avatarSize: { type: String, required: false, default: '32px' },
    fontSize: { type: String, required: false, default: '10px' },
    disabled: Boolean,
    accounts: {
      type: Array,
      default: () => [],
    },
    maxItemsToShow: {
      type: Number,
      default: 15,
    },
    loading: Boolean,
  },

  computed: {
    moreItemsSelected() {
      const moreUsers = this.accounts.length - this.maxItemsToShow
      return moreUsers > 0 ? moreUsers : null
    },
  },

  methods: {
    getItemTitle(item) {
      return item.title || this.getFullName(item)
    },
  },
}
</script>

<style scoped lang="scss">
.chip-over-chip {
  margin-left: -6px;
}

.more-items-selected {
  cursor: pointer;
  border-radius: 16px;
  margin-left: -6px;
  position: relative;
}
</style>

<style lang="scss">
.selection-avatar .v-skeleton-loader__avatar {
  height: 32px !important;
  width: 32px !important;
}
.selection-skeletons .v-skeleton-loader .v-skeleton-loader__bone {
  background: $color-blue-grey-lighten2 !important;
}
</style>
